import * as React from 'react';
import { Feature } from '@tencent/workbench';
import { CheckboxWithLabel } from '../components/checkbox-component';
import { BaseCheckFeature } from './base-check-feature';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TOOLBAR_REPORT_MAP } from '@src/framework/workbench/middleware/report';

@Feature()
export class BaseGuideFeature extends BaseCheckFeature {
    public getContent = () => (
        <CheckboxWithLabel
            label={this.config.content}
            checked={this.buttonChecked}
            onChange={() => {
                this.buttonChecked = !!this.buttonChecked;
                this.updateDisplay();
                this.report();
            }}
        />
    );

    /**
     * 更新存储的数据：更新是否展示
     */
    protected updateDisplay() {}

    private report() {
        tdw({
            ...TOOLBAR_REPORT_MAP[this.config.id](),
            ver5: this.buttonChecked ? 1 : 0,
        });
    }
}
